export default "__VITE_ASSET__BlcEFEpX__"